import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeathericonComponent } from '../../../feathericon/feathericon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-all-user',
    imports: [CommonModule, RouterModule, 
        // FeathericonComponent
    ],
    templateUrl: './all-user.component.html',
    styleUrls: ['./all-user.component.scss']
})
export class AllUserComponent {





}
